var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-page-header"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(this.$t("schedule.main_page_title")))])])}
var staticRenderFns = []

export { render, staticRenderFns }